<div ng-controller="systemController as systemCtrl">
    <c-auto-form config="systemCtrl.autoFormConfig"></c-auto-form>
</div>